import AuthContext, { useAuth } from "./Component";
import { connect } from "react-redux";
import { storeUser } from "store/actions/user";

const mapDispatchToProps = (dispatch) => ({
  saveUser: (payload) => dispatch(storeUser(payload)),
});

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthContext);
export { useAuth };
